import React from 'react';

import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './styles/tailwind.css';
import './styles/global.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
	dsn: 'https://3b95f567a3524ebee2be49ff49927f8b@o4509781531557888.ingest.de.sentry.io/4509781532541008',
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.reactRouterV7BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
		Sentry.replayIntegration(),
	],
	// Performance Monitoring
	tracesSampleRate: 0.2,
	tracePropagationTargets: ['localhost', /^https:\/\/app\.b2b-hero\.com/],
	// Session Replay
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,

	// Only enable Sentry in production/staging
	enabled:
		['production', 'staging'].includes(process.env.NODE_ENV) ||
		['production', 'staging'].includes(process.env.REACT_APP_NODE_ENV),
	environment: process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Sentry.ErrorBoundary
			fallback={
				<div className="p-8 text-center">
					<h1>Unerwarteter Fehler</h1>
					<p>Bitte laden Sie die Seite neu.</p>
				</div>
			}
		>
			<App />
		</Sentry.ErrorBoundary>
	</React.StrictMode>,
);

reportWebVitals();
